import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { StageResourceRequest } from '@/models';

@Injectable({
    providedIn: 'root',
})
export class EditalRecursosService {
    private baseUrl = `${environment.apiUrl}/admin/editais`;

    constructor(private http: HttpClient) { }

    deleteStageResource(editalId: number, resourceId: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${editalId}/recursos/${resourceId}`);
    }

    updateStageResource(editalId: number, resourceId: number, data: StageResourceRequest): Observable<StageResourceRequest> {
        return this.http.put<StageResourceRequest>(`${this.baseUrl}/${editalId}/recursos/${resourceId}`, data);
    }
}
